import React from 'react'
import moment from 'moment'
import "./Test.css"

const ProjectSummary = ({ project }) => {
    return (
        <div>
            <form className="card-box">
                <form className="box-title">
                    <spen className="card-name">{project.title}</spen>
                </form>
                <form className="box-name">
                    <p className="card-post1">Posted by {project.authorFirstName} {project.LastName}</p>
                    <p className="card-post2">{moment(project.createdAt.toDate()).calendar()}</p>
                </form>
            </form>
        </div>
    )
}

export default ProjectSummary